/* eslint-disable */
var MTIProjectId = '7248d2d5-453d-4304-bd86-322362f31c46';
(function(oryxGlobals) {
	var mtiTracking = document.createElement('script');
	mtiTracking.type = 'text/javascript';
	mtiTracking.async = 'true';
	mtiTracking.src = oryxGlobals.templateUrl + '/scripts/mtiFontTrackingCode.js';
	(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(mtiTracking);
})(window.oryxGlobals);
/* eslint-enable */
